<template>
  <b-card>
    <validation-observer ref="roleForm">
      <b-form>
        <b-row class="mt-2">
          <b-col md="6">
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Role Name"
                rules="required"
              >
                <b-form-input
                  v-model="form.role_name"
                  :state="errors.length > 0 ? false : null"
                  type="text"
                  placeholder="Role Name"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <div class="text-uppercase text-bold"></div>
            <div class="table-responsive">
              <table class="table table-striped table-hover">
                <thead>
                  <tr>
                    <th>Module</th>
                    <th>Read</th>
                    <th>Create</th>
                    <th>Update</th>
                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(mod, index) in role_modules_map">
                    <tr :key="'parent_' + index">
                      <td>
                        <p class="d-flex align-items-center mb-0">
                          <b-form-checkbox
                            :checked="mod.select_all_in_parent"
                            @change="toggleSelectAllParent(index, $event)"
                            class="mr-1"
                            :disabled = "isSuperAdmin"
                          ></b-form-checkbox>
                          <span
                            v-if="mod.children && mod.children.length > 0"
                            :class="{ 'rotate-arrow': mod.isOpen }"
                            @click="toggleArrow(index)"
                          >
                            ▶
                          </span>
                          <span class="ml-1">{{
                            mod.module_name_frontend ? mod.module_name_frontend : humanize(mod.module_name)
                          }}</span>
                        </p>
                      </td>
                      <td>
                        <label class="form-checkbox">
                          <input
                            type="checkbox"
                            :checked="mod.read"
                            @change="
                              updateParentPermission(index, 'read', $event.target.checked)
                            "
                            :disabled = "isSuperAdmin"
                          />
                          <i class="form-icon"></i>
                        </label>
                      </td>
                      <td>
                        <label class="form-checkbox">
                          <input
                            type="checkbox"
                            :checked="mod.create"
                            @change="
                              updateParentPermission(index, 'create', $event.target.checked)
                            "
                            :disabled = "isSuperAdmin"
                          />
                          <i class="form-icon"></i>
                        </label>
                      </td>
                      <td>
                        <label class="form-checkbox">
                          <input
                            type="checkbox"
                            :checked="mod.update"
                            @change="
                              updateParentPermission(index, 'update', $event.target.checked)
                            "
                            :disabled = "isSuperAdmin"
                          />
                          <i class="form-icon"></i>
                        </label>
                      </td>
                      <td>
                        <label class="form-checkbox">
                          <input
                            type="checkbox"
                            :checked="mod.delete"
                            @change="
                              updateParentPermission(index, 'delete', $event.target.checked)
                            "
                            :disabled = "isSuperAdmin"
                          />
                          <i class="form-icon"></i>
                        </label>
                      </td>
                    </tr>
                    <tr
                      v-if="mod.children && mod.children.length > 0"
                      :key="'child_' + index"
                    >
                      <td colspan="5" class="p-0">
                        <b-collapse
                          :id="'collapse-' + index"
                          v-model="mod.isOpen"
                        >
                          <table class="table table-striped table-hover">
                            <tbody>
                              <tr
                                v-for="(m, i) in mod.children"
                                :key="'child_roles_table' + i"
                              >
                                <td class="d-flex">
                                  <b-form-checkbox
                                    class=""
                                    :checked="m.selected_all_in_children"
                                    @change="
                                      toggleSelectAllChild(index, i, $event)
                                    "
                                    :disabled = "isSuperAdmin"
                                  >
                                  </b-form-checkbox>
                                  <p>{{ m.module_name_frontend ? m.module_name_frontend: humanize(m.module_name) }}</p>
                                </td>
                                <td>
                                  <label class="form-checkbox">
                                    <input
                                      type="checkbox"
                                      :checked="m.read"
                                      @change="
                                        updateChildPermission(
                                          index,
                                          i,
                                          'read',
                                          $event.target.checked
                                        )
                                      "
                                      :disabled = "isSuperAdmin"
                                    />
                                    <i class="form-icon"></i>
                                  </label>
                                </td>
                                <td>
                                  <label class="form-checkbox">
                                    <input
                                      type="checkbox"
                                      :checked="m.create"
                                      @change="
                                        updateChildPermission(
                                          index,
                                          i,
                                          'create',
                                          $event.target.checked
                                        )
                                      "
                                      :disabled = "isSuperAdmin"
                                    />
                                    <i class="form-icon"></i>
                                  </label>
                                </td>
                                <td>
                                  <label class="form-checkbox">
                                    <input
                                      type="checkbox"
                                      :checked="m.update"
                                      @change="
                                        updateChildPermission(
                                          index,
                                          i,
                                          'update',
                                          $event.target.checked
                                        )
                                      "
                                      :disabled = "isSuperAdmin"
                                    />
                                    <i class="form-icon"></i>
                                  </label>
                                </td>
                                <td>
                                  <label class="form-checkbox">
                                    <input
                                      type="checkbox"
                                      :checked="m.delete"
                                      @change="
                                        updateChildPermission(
                                          index,
                                          i,
                                          'delete',
                                          $event.target.checked
                                        )
                                      "
                                      :disabled = "isSuperAdmin"
                                    />
                                    <i class="form-icon"></i>
                                  </label>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </b-collapse>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </b-col>
          <b-col cols="12" class="text-center">
            <b-button variant="primary" type="submit" @click.prevent="saveRole" v-if="!isSuperAdmin">
              Save
            </b-button>
            <b-alert variant="info" show v-else class="mt-2">
              Super Admin role cannot be modified
            </b-alert>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BCard,
  BFormInput,
  BFormGroup,
  BForm,
  BRow,
  BCol,
  BButton,
  BCardText,
  BFormTextarea,
  BTable,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import { required } from "@validations";
import { BFormSelect } from "bootstrap-vue";
import * as UserServices from "@/apiServices/UsersServices";
import ToastificationContentVue from "@/@core/components/toastification/ToastificationContent.vue";
import { humanize } from "@/utils/helpers";

export default {
  name: "IngredientForm",
  directives: {
    Ripple,
  },
  components: {
    BFormSelect,
    BTable,
    ValidationProvider,
    ValidationObserver,
    BCard,
    BCardText,
    BFormTextarea,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    vSelect,
  },
  data() {
    return {
      item_id: null,
      form: {
        role_id: null,
        role_name: null,
      },
      role_modules_map: [],
      required,
      isOpen: false,
      isSuperAdmin: false,
    };
  },
  methods: {
    humanize,
    toggleSelectAllParent(index, isChecked) {
      const parent = this.role_modules_map[index];

      parent.read = isChecked;
      parent.create = isChecked;
      parent.update = isChecked;
      parent.delete = isChecked;

      parent.children?.forEach((child) => {
        child.read = isChecked;
        child.create = isChecked;
        child.update = isChecked;
        child.delete = isChecked;
        child.selected_all_in_children = isChecked;
      });

      this.checkParentSelectAll(index);
    },

    toggleSelectAllChild(p_index, c_index, isChecked) {
      const child = this.role_modules_map[p_index].children[c_index];

      child.read = isChecked;
      child.create = isChecked;
      child.update = isChecked;
      child.delete = isChecked;

      child.selected_all_in_children = isChecked;

      this.checkParentSelectAll(p_index);
    },

    updateParentPermission(p_index, permission, value) {
      this.role_modules_map[p_index][permission] = value;
      if(permission == "read"){
        const value = this.role_modules_map[p_index][permission];
        if(!value){
          this.role_modules_map[p_index]['create'] = false;
          this.role_modules_map[p_index]['update'] = false;
          this.role_modules_map[p_index]['delete'] = false;
          this.role_modules_map[p_index].children.forEach((item)=>{
            item.create = false;
            item.delete = false;
            item.update = false;
            item.read = false;
          })
        }
        else{
          this.role_modules_map[p_index].children.forEach((item)=>{
            item[permission] = true;
          })
      }
      }
      else{
        if(value){
          this.role_modules_map[p_index][permission] = true;
          this.role_modules_map[p_index].children.forEach((item)=>{
              item[permission] = true;
          })
          this.role_modules_map[p_index]['read'] = true;
          this.role_modules_map[p_index].children.forEach((item)=>{
            item.read = true;
          })
        }
        else{
          this.role_modules_map[p_index][permission] = false;
          this.role_modules_map[p_index].children.forEach((item)=>{
              item[permission] = false;
          })
        }
      }
      this.checkParentSelectAll(p_index);
      this.role_modules_map[p_index].children.forEach((item,index)=>{
        // console.log("wooieioeo",this.role_modules_map[p_index].children[index])
        this.checkChildSelectAll(p_index,index)
      })
    },

    updateChildPermission(p_index, c_index, permission, value) {
      const child = this.role_modules_map[p_index].children[c_index];
      child[permission] = value;
      if(permission == "read"){
        const value = child[permission];
        if(!value){
          child['create'] = false;
          child['update'] = false;
          child['delete'] = false;
        }
      }
      else{
        child['read'] = true;
        this.role_modules_map[p_index].read = true;
      }
      this.checkChildSelectAll(p_index, c_index);
      this.checkParentSelectAll(p_index);
    },

    checkParentSelectAll(p_index) {
      const parent = this.role_modules_map[p_index];
      const allParentPermissions =
        parent.read && parent.create && parent.update && parent.delete;
      const allChildrenPermissions = parent.children?.every(
        (child) => child.read && child.create && child.update && child.delete
      );
      parent.select_all_in_parent = allParentPermissions && allChildrenPermissions;
      this.manageSelect(p_index);
    },

    checkChildSelectAll(p_index, c_index) {
      const child = this.role_modules_map[p_index].children[c_index];
      child.selected_all_in_children =
        child.read && child.create && child.update && child.delete;
      // console.log('selected fwoe',child.selected_all_in_children)
    },

    manageSelect(p_index, c_index){
      const parent = this.role_modules_map[p_index];
      const child = this.role_modules_map[p_index].children[c_index];

      ['read', 'create', 'update', 'delete'].forEach(perms => {
        if(parent.children?.length > 0){
          parent[perms] = parent.children?.some(c => c[perms]);
        }      
        if(perms === 'read' && !parent.read){
          ['create', 'update', 'delete'].forEach(p =>{
            parent[p] = false;
            parent.children?.forEach(child => {
              child[p] = false
            })
          })
          parent.children?.forEach(child => {
            child.read = false
          })
        }
      })

    },

    toggleArrow(index) {
      this.role_modules_map[index].isOpen =
        !this.role_modules_map[index].isOpen;
    },

    async getRole() {
      try {
        const response = await UserServices.getSingleRole({
          role_id: this.form.role_id,
        });
        if (response.data.status) {
          this.form = response.data.data;
        }
      } catch (err) {
        console.log("Error in getting role  ", err);
      }
    },
    async getRoleModuleMap() {
      try {
        const response = await UserServices.getRoleModuleMap({
          role_id: this.form.role_id,
        });
        if (response.data.status) {
          const data = response.data.data;
          this.role_modules_map = data.map((mod) => {
            const allPermissionsSelected =
              mod.read && mod.update && mod.delete && mod.create;
            const allChildrenSelected = mod.children?.every(
              (child) =>
                child.read && child.update && child.delete && child.create
            );
            return {
              ...mod,
              isOpen: false,
              select_all_in_parent: allPermissionsSelected && allChildrenSelected,
              children:
                mod.children?.map((child) => ({
                  ...child,
                  selected_all_in_children:
                    (child.read && child.update && child.delete && child.create) ? true : false,
                })) || [],
            };
          });
          // console.log(this.role_modules_map,'foewhfiowheio')
        }
      } catch (err) {
        console.log("Error in getting role module map ", err);
      }
    },
    async saveRole() {
      this.$refs.roleForm.validate().then(async (success) => {
        if (!success) return;
        let data = this.role_modules_map;

        for ( const rm_map of this.role_modules_map){
          if (rm_map.children && rm_map.children.length > 0) {
            data = [...data, ...rm_map.children ];
          }
        }
        try {
          const response = await UserServices.saveRole({
            role: this.form,
            role_modules_map: data,
          });

          if (response.data.status) {
            this.$toast({
              component: ToastificationContentVue,
              props: {
                title: response.data.message || "Success",
                icon: "EditIcon",
                variant: "success",
              },
            });
            this.$router.go(-1);
          }
        } catch (error) {
          console.log("Error in saving role ", error);
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: "Error Saving Role",
              icon: "EditIcon",
              variant: "danger",
            },
          });
        }
      });
    },
    toggleArrow(index) {
      this.role_modules_map[index].isOpen =
        !this.role_modules_map[index].isOpen;
    },

    select_parent(index) {
      const parent = this.role_modules_map[index];
      parent.select_all_in_parent = !parent.select_all_in_parent;
      parent.select_all_in_parent = !parent.select_all_in_parent;

      // Update parent permissions
      parent.read = parent.select_all_in_parent;
      parent.create = parent.select_all_in_parent;
      parent.update = parent.select_all_in_parent;
      parent.delete = parent.select_all_in_parent;

      // Update child permissions
      parent.children.forEach((child) => {
        child.read = parent.select_all_in_parent;
        child.create = parent.select_all_in_parent;
        child.update = parent.select_all_in_parent;
        child.delete = parent.select_all_in_parent;
      });
    },
  },
  async beforeMount() {
    const role_id = this.$route.params.role_id;
    if (role_id && !isNaN(role_id)) {
      this.form.role_id = role_id;
      await this.getRole();
      this.isSuperAdmin = this.form.role_id === 1 || this.form.role_name === 'Super Admin';

      if (this.isSuperAdmin) {
        this.role_modules_map = this.role_modules_map.map(mod => {
          mod.read = true;
          mod.create = true;
          mod.update = true;
          mod.delete = true;
          mod.select_all_in_parent = true;
          if (mod.children) {
            mod.children = mod.children.map(child => {
              child.read = true;
              child.create = true;
              child.update = true;
              child.delete = true;
              child.selected_all_in_children = true;
              return child;
            });
          }
          return mod;
        });
      }
    }
    await this.getRoleModuleMap();
  },
};
</script>

<style>
.rotate-arrow {
  display: inline-block;
  transform: rotate(90deg);
  transition: transform 0.3s ease-in-out;
}

.table_role {
  table-layout: fixed;
  width: 100%;
}

.th,
.td {
  padding: 8px;
  text-align: left;
  vertical-align: top;
}

.d-flex {
  display: flex;
  align-items: center;
}

</style>
